interface Map {
  [key: string]: {
    [key: string]: string | undefined;
  };
}

const LANG_MAP: Map = {
  page_title: {
    en_US: "Apply Now for a Canadian Mortgage",
    fr_CA: "Appliquer maintenant",
  },
  lets_talk: {
    en_US: "Let's Talk",
    fr_CA: "Parlons",
  },
  read_more: {
    en_US: "Read More",
    fr_CA: "En savoir plus",
  },
  read_less: {
    en_US: "Read Less",
    fr_CA: "Lire moins",
  },
  next: {
    en_US: "Next",
    fr_CA: "Suivant",
  },
  back: {
    en_US: "Back",
    fr_CA: "Retour",
  },
  selectProvince: {
    en_US: "Select Province",
    fr_CA: "Sélectionnez la province",
  },
  selectPropertyType: {
    en_US: "Select Property Type",
    fr_CA: "Sélectionnez le type de propriété",
  },
  firstName: {
    en_US: "First Name",
    fr_CA: "Prénom",
  },
  lastName: {
    en_US: "Last Name",
    fr_CA: "Nom de famille",
  },
  phoneNumber: {
    en_US: "Phone Number",
    fr_CA: "Numéro de téléphone",
  },
  emailAddress: {
    en_US: "Email Address",
    fr_CA: "Courriel",
  },
  amount: {
    en_US: "Amount must be at least $50,000",
    fr_CA: "Le montant doit être d’au moins 50 000 $",
  },
  equity: {
    en_US: "Amount must be at least $25,000",
    fr_CA: "Le montant doit être d’au moins 50 000 $",
  },
  propertyValue: {
    en_US: "Property value must be at least $50,000",
    fr_CA: "La valeur de la propriété doit être d’au moins 50 000 $.",
  },
  totalDownpayment: {
    en_US:
      "This must be at least 5% of the purchase or $5000, whichever is greater",
    fr_CA:
      "La mise de fonds doit correspondre à au moins 5 % du montant de l’achat ou à 5000 $, selon le montant le plus élevé.",
  },
  householdIncome: {
    en_US: "Your income must be at least $40,000.",
    fr_CA: "Votre revenu doit être d’au moins 40 000 $.",
  },
  house: {
    en_US: "A house",
    fr_CA: "Une maison",
  },
  condo: {
    en_US: "A condo",
    fr_CA: "Un condominium",
  },
  apartment: {
    en_US: "An apartment",
    fr_CA: "Un appartement",
  },
  cottage: {
    en_US: "A cottage",
    fr_CA: "Un chalet",
  },
  email: {
    en_US: "email@email.com",
    fr_CA: "courriel@courriel.com",
  },
  select: {
    en_US: "Select",
    fr_CA: "Sélectionnez",
  },
  close: {
    en_US: "Close",
    fr_CA: "Fermer",
  },
  team_leads: {
    en_US: "Team Leads",
    fr_CA: "Chefs d'équipe",
  },
  mortgage_agents: {
    en_US: "Mortgage Agents",
    fr_CA: "Agents hypothécaires",
  },
  underwriters: {
    en_US: "Underwriters",
    fr_CA: "Souscription",
  },

  executive_team: {
    en_US: "Executive Team",
    fr_CA: "Équipe de direction",
  },
  marketing: {
    en_US: "Marketing",
    fr_CA: "Marketing",
  },
  corporate_resources: {
    en_US: "Corporate Resources",
    fr_CA: "Ressources de l'entreprise",
  },
  tech_resources: {
    en_US: "Technology Resources",
    fr_CA: "Ressources technologiques",
  },
  finance_resources: {
    en_US: "Finance Resources",
    fr_CA: "Ressources financières",
  },
  licensing: {
    en_US:
      "8Twelve Mortgage Corp. Licenses: Mortgage Brokerage Ontario #13072, British Columbia #X300983, Alberta #2122265990, Saskatchewan #508695, Manitoba #RW-2011175,  Mortgage Brokerage Firm Quebec #606914, New Brunswick #21004252, Nova Scotia #4342039, Newfoundland/Labrador #88786, PEI #755902715, Yukon #839770",
    fr_CA:
      "8Twelve Licences de société hypothécaire: Mortgage Brokerage L’Ontario n° 13072, La Colombie-Britannique n° X300983, L’Alberta n° 2122265990, La Saskatchewan n° 508695, Le Manitoba n° RW-2011175, Cabinet en courtage hypothécaire Le Québec n° 606914, Le Nouveau-Brunswick n° 21004252, La Nouvelle-Écosse n° 4342039, La Terre-Neuve-et-Labrador n° 88786, Île-du-Prince-Édouard n° 755902715, Le Yukon (Territoire) n° 839770",
  },
};

export const acn_i18n: Map = {
  title: {
    en_US: "8Twelve has a mortgage just for you. Let's find it.",
    fr_CA: "8Twelve a une hypothèque juste pour vous. Trouvons-la.",
  },
  advance_acn_customers: {
    en_US: "We advance the upfront appraisal costs for all ACN customers!",
    fr_CA:
      "Nous avançons les coûts d’évaluation initiaux pour tous les clients d’ACN!",
  },
  get_your_mortgage_approved: {
    en_US: "Get Your Mortgage Approved",
    fr_CA: "Obtenez une préapprobation hypothécaire",
  },
  lets_get_started: {
    en_US: "Let's get started!",
    fr_CA: "Commençons!",
  },
  acn_ibo_number: {
    en_US: "ACN IBO Number",
    fr_CA: "Numéro PEI de l’ACN",
  },
  acn_firstName: {
    en_US: "First Name",
    fr_CA: "Prénom",
  },
  acn_lastName: {
    en_US: "Last Name",
    fr_CA: "Nom de famille",
  },
  acn_email: {
    en_US: "Email",
    fr_CA: "Courriel",
  },
  acn_phone: {
    en_US: "Phone",
    fr_CA: "Téléphone",
  },
  how_can_we_help: {
    en_US: "How Can We Help?",
    fr_CA: "Comment pouvons-nous aider?",
  },
  purchase: {
    en_US: "Purchase (I have a closing date)",
    fr_CA: "Achat (j’ai une date de clôture)",
  },
  refinance: {
    en_US: "Refinance",
    fr_CA: "Refinancement",
  },
  renewal: {
    en_US: "Renewal / Switch / Transfer",
    fr_CA: "Renouvellement / transfert",
  },
  heloc: {
    en_US: "Home Equity Line of Credit",
    fr_CA: "Marge de crédit hypothécaire",
  },
  debt_consolidation: {
    en_US: "Debt Consolidation",
    fr_CA: "Consolidation de dettes",
  },
  is_there_anything: {
    en_US: "Is there anything else we should know?",
    fr_CA: "Y a-t-il autre chose que nous devrions savoir?",
  },
  all_above_information: {
    en_US:
      "All above information is collected by 8Twelve Mortgage Corporation only.",
    fr_CA:
      "Tous les renseignements ci-dessus sont recueillis par 8Twelve Mortgage Corporation uniquement.",
  },
  consent_one: {
    en_US:
      "Please check this box to receive updates and offers about our electronic messages in compliance with CASL.",
    fr_CA:
      "Veuillez cocher cette case pour recevoir des mises à jour et des offres au sujet de nos messages électroniques conformément à la Loi canadienne anti-pourriel (LCAP).",
  },
  consent_two: {
    en_US:
      "You can unsubscribe anytime by clicking the 'unsubscribe' link in our emails. Review our",
    fr_CA: `Vous pouvez vous désabonner en cliquant sur le lien « Se désabonner » dans nos courriels. Pour en savoir plus, consultez notre`,
  },
  consent_three: {
    en_US: "Privacy Policy",
    fr_CA: "Politique de confidentialité.",
  },
  consent_four: {
    en_US: "for more details.",
    fr_CA: "",
  },
  terms_one: {
    en_US: "* Refer to the",
    fr_CA: "* Consultez les",
  },
  terms_two: {
    en_US: "Terms & Conditions and Privacy Policy",
    fr_CA: "conditions générales et à la politique de confidentialité",
  },
  terms_three: {
    en_US: "for complete details. Usage subject to 8Twelve Mortgage Corp.",
    fr_CA: "pour plus de détails. Utilisation soumise à 8Twelve Mortgage Corp.",
  },
  thank_you_title: {
    en_US: "Thank you for your submission!",
    fr_CA: "Merci pour votre soumission!",
  },
  thank_you_subtitle: {
    en_US:
      "Thank you for your submission! Your mortgage inquiry has been received. An 8Twelve Mortgage Agent will be in contact with you shortly.",
    fr_CA:
      "Merci pour votre soumission! Votre demande de prêt hypothécaire a été reçu. Un agent hypothécaire de 8Twelve vous contactera sous peu.",
  },
  all_rights_reserved: {
    en_US: "© 8Twelve Mortgage Corporation. All Rights Reserved.",
    fr_CA: "© 8Twelve Mortgage Corporation. Tous droits réservés.",
  },
  brokerage_license: {
    en_US: "Brokerage Licenses: ",
    fr_CA: "Licences de courtage :",
  },
  address: {
    en_US: "45 Sheppard Ave East, Suite 211, Toronto, Ontario, M2N 5W9, Canada",
    fr_CA:
      "45 avenue Sheppard Est, bureau 211, Toronto (Ontario) M2N 5W9, Canada",
  },
  required: {
    en_US: "Required",
    fr_CA: "Requis",
  },
  apply_now: {
    en_US: "Apply Now",
    fr_CA: "Appliquer maintenant",
  },
  consent: {
    en_US: `I agree and consent to receive email/phone call/sms communication from 8Twelve Mortgage Corp., including updates and offers about their services and rates. I understand that I can unsubscribe at any time.<br/>By submitting this form you agree to our  <a
    href="/privacy-policy"
    class="underline"
    target="_black"
  >Privacy Policy.</a>`,
    fr_CA: `J'accepte et consens à recevoir des communications par courriel/téléphone/sms de 8Twelve Mortgage Corp., y compris des mises à jour et des offres concernant leurs services et tarifs. Je comprends que je peux me désabonner à tout moment. <br/>
    Par le fait de soumettre ces renseignements, vous acceptez notre <a
    href="/privacy-policy"
    class="underline"
    target="_black"
  >politique de confidentialité.</a>`,
  },
  relation: {
    en_US:
      "8Twelve Has Built Excellent Relationships with Canada's Top Lenders",
    fr_CA:
      "8Twelve a établi d'excellentes relations avec les meilleurs prêteurs du Canada",
  },

  welcome: {
    en_US: "Welcome",
    fr_CA: "Bienvenue",
  },
  chose_your_preferred_lang: {
    en_US: "Please choose your preferred language.",
    fr_CA: "Veuillez choisir la langue de votre choix.",
  },
  continue: {
    en_US: "continue",
    fr_CA: "continuer",
  },
  acn_independent_business_owner_login: {
    en_US: "ACN Independent Business Owner Login",
    fr_CA:
      "Ouverture de session des propriétaires d’entreprises indépendants ACN",
  },
  business_id: {
    en_US: "Business ID",
    fr_CA: "Numéro d’entreprise",
  },
  go: {
    en_US: "Go!",
    fr_CA: "C’est parti!",
  },
  please_include_leading_zeros: {
    en_US: "Please include any leading zeros.",
    fr_CA: "Veuillez inclure tous les zéros du début.",
  },
  eight_twelve_training_portal: {
    en_US: "8Twelve Mortgage ACN Training Portal",
    fr_CA: "Portail de formation ACN 8Twelve Hypothèque",
  },
  eight_twelve_training_portal_description: {
    en_US:
      "Welcome to the essential 8Twelve Mortgage Training! The training video has a runtime of around 15 minutes. By watching this training, you'll gain all the valuable insights you need to refer customers to 8Twelve Mortgage with confidence and success. Once you've completed the online video training, it's time to move forward to the Questionnaire. ",
    fr_CA:
      "Bienvenue à la formation essentielle de 8Twelve Hypothèque! La vidéo de formation dure environ 15 minutes. En la visionnant, vous obtiendrez tous les précieux renseignements dont vous avez besoin pour diriger les clients vers 8Twelve Hypothèque en toute confiance et avec succès. Une fois que vous avez terminé la vidéo de formation en ligne, vous pourrez passer au questionnaire. ",
  },
  continue_to_question: {
    en_US: "Continue to Questionnaire",
    fr_CA: "Passer au questionnaire",
  },
  review_and_respond: {
    en_US:
      "Welcome to the essential 8Twelve Mortgage Training! The training video has a runtime of around 15 minutes. By watching this training, you'll gain all the valuable insights you need to refer customers to 8Twelve Mortgage with confidence and success. Once you've completed the online video training, it's time to move forward to the Questionnaire.",
    fr_CA:
      "Bienvenue à la formation essentielle de 8Twelve Hypothèque! La vidéo de formation dure environ 15 minutes. En la visionnant, vous obtiendrez tous les précieux renseignements dont vous avez besoin pour diriger les clients vers 8Twelve Hypothèque en toute confiance et avec succès. Une fois que vous avez terminé la vidéo de formation en ligne, vous pourrez passer au questionnaire.",
  },
  please_note: {
    en_US: "Continue to Questionnaire",
    fr_CA: "Passer au questionnaire",
  },
  questionnaire: {
    en_US: "Questionnaire",
    fr_CA: "Questionnaire",
  },
  choose_one: {
    en_US: "(choose one)",
    fr_CA: "(Choisissez une seule réponse.)",
  },
  questionnaire_result: {
    en_US: "Questionnaire Results ",
    fr_CA: "Résultats du questionnaire",
  },
  fail_one: {
    en_US:
      "Sorry, but you did not pass the 8Twelve Mortgage Training Questionnaire. ",
    fr_CA:
      "Désolé, mais vous n’avez pas réussi le questionnaire de formation de 8Twelve Hypothèque.",
  },
  fail_two: {
    en_US: "You answered {{X}} questions(s) incorrectly.",
    fr_CA: "Vous avez répondu incorrectement à {{X}} question(s).",
  },
  fail_three: {
    en_US:
      "Please review the training video again and retake the questionnaire at a later time.",
    fr_CA:
      "Veuillez revoir la vidéo de formation et reprendre le questionnaire plus tard.",
  },
  view_training_video: {
    en_US: "View training video",
    fr_CA: "Visionner la vidéo de formation",
  },
  congratulations: {
    en_US: "Congratulations!",
    fr_CA: "Félicitations!",
  },
  pass_one: {
    en_US: "You have passed the 8Twelve Mortgage Training Questionnaire.",
    fr_CA:
      "Vous avez réussi le questionnaire de formation de 8Twelve Hypothèque.",
  },
  pass_two: {
    en_US:
      "No further steps are required. Visit the mortgage page in your storefront to start today.",
    fr_CA:
      "Aucune autre étape n’est requise. Consultez la page des prêts hypothécaires à votre comptoir de service pour commencer dès aujourd’hui.",
  },
  all_set: {
    en_US: "You are all set!",
    fr_CA: "Vous êtes prêts!",
  },
  completed_one: {
    en_US:
      "You have already successfully completed the 8Twelve Mortgage Training!",
    fr_CA:
      "Vous avez déjà terminé la formation de 8Twelve Hypothèque avec succès!",
  },
  completed_two: {
    en_US:
      "No further steps are required. Visit the mortgage page in your storefront to start today.",
    fr_CA:
      "Aucune autre étape n’est requise. Consultez la page des prêts hypothécaires à votre comptoir de service pour commencer dès aujourd’hui.",
  },
  end_of_video: {
    en_US:
      "Note: At the end of the video you’ll be taken to the questionnaire to get the accreditation completed. Quebec is only open for Purchases.",
    fr_CA: `Remarque : À la fin de la vidéo, vous serez redirigé vers le questionnaire pour obtenir l'accréditation. 
      Le Québec est ouvert uniquement aux achats.`,
  },
  end_of_video_develop: {
    en_US:
      "Note: At the end of the video you’ll be taken to the questionnaire to get the accreditation completed.",
    fr_CA:
      "Remarque : À la fin de la vidéo, vous serez redirigé vers le questionnaire pour obtenir l'accréditation.",
  },
  residential_only: {
    en_US: "for Residential Mortgages only",
    fr_CA: "Pour prêts hypothécaires résidentiels seulement",
  },
  not_launching_on_qubec: {
    en_US:
      "The initial launch temporarily excludes Quebec and you will be unable to refer Quebec customers at this time. We encourage you to become accredited so that you are prepared to offer 8Twelve Mortgage to your family and friends.",
    fr_CA:
      "Le lancement initial ne comprend pas le Québec temporairement et vous ne serez pas en mesure de recommander des clients du Québec pour le moment. Nous vous encourageons à devenir accrédité afin que vous soyez prêt à offrir 8Twelve Hypothèque aux membres de votre famille et à vos amis.",
  },
  not_launching_on_qubec_two: {
    en_US: "Quebec launch announcement coming soon.",
    fr_CA: "Annonce du lancement au Québec à venir bientôt.",
  },
  introduction_title: {
    en_US: `Please review and respond to each question provided below. It is important to answer all of the questions. You won't be able to skip one. When you are content with your responses, please click on the "Submit" button located at the bottom of the page to receive your questionnaire results promptly.`,
    fr_CA: `Veuillez passer en revue chaque question ci-dessous et y répondre. Il est important de répondre à toutes les questions. Lorsque vous êtes satisfait(e) de vos réponses, veuillez cliquer sur le bouton « Soumettre » situé au bas de la page pour recevoir rapidement les résultats de votre questionnaire.`,
  },
  introduction_description: {
    en_US:
      "Please note: You need to answer all of the questions correctly to pass. ",
    fr_CA:
      "Veuillez noter que vous devez répondre correctement à toutes les questions pour réussir.",
  },
};

export default LANG_MAP;
